import React from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { formatFsdbmThreshold } from '../../helpers/utils';

export const FSDBMMessage = ({ threshold, isFree }) => {
  const bodfsCutoff = useConfigService('fs:bodfsCutoff') || '4pm';
  if (!threshold) {
    return null;
  }
  const qualifyingMessage = isFree ? 'You earned ' : ''
  const formattedThreshold = formatFsdbmThreshold(threshold);
  const orderAmount = isFree ? ' — ': ` with $${formattedThreshold}+ of eligible items when you `
  return (
    <div className={`sui-rounded-md sui-bg-[linear-gradient(90deg,#E0F8ED_0%,#9CE8C4_100%)] sui-p-2 sui-text-base ${isFree ? '' : 'sui-mb-2'}`} data-testid="fsdbm-message">
      {qualifyingMessage}
      <span className="sui-text-success sui-font-bold">{'FREE '}</span>
      <span className="sui-font-bold">Delivery Today</span>
      {orderAmount}
      order by {bodfsCutoff}{isFree ? '*' : ''}
    </div>
  );
}